// extracted by mini-css-extract-plugin
export default {"list":"GNEIC","mobileList":"jW4bK","listPaddingTop":"_1KHUG","basketViewDesktop":"L2n7h"};